module.exports = __webpack_public_path__ + "img/paishui (1).c56ef383.png";